import React from 'react';
import { useNavigate } from 'react-router-dom';
import api from "api/axiosConfig";
import API_BASE from "configs/hostConfig";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormLabel,
  Input,
  // Select,
  VStack,
  // Stack,
  Link,
  Text,
  Flex,
  Radio,
  RadioGroup,
  FormErrorMessage,
  useToast,
} from '@chakra-ui/react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Link as RouterLink } from 'react-router-dom';
import BackgroundWrapper from 'components/Background/Background';
import theme from 'ui/theme/theme';
import { TbAlertCircle } from 'react-icons/tb';

const Signup = () => {
  const navigate = useNavigate();
  const toast = useToast();

  function toastMessage(msg) {
    toast({
      position: 'top',
      render: () => (
        <Box
          border="1px solid"
          borderColor={theme.colors.semantics.warning}
          p={4}
          bg={theme.colors.semantics['error-light']}
          borderRadius={12}
          wordBreak="break-all"
        >
          <Flex>
            <TbAlertCircle color={theme.colors.semantics.error} />
            <Flex ml="12px" flex="1">
              <Text fontWeight="bold" ml="2">
                {msg}
              </Text>
            </Flex>
          </Flex>
        </Box>
      ),
      duration: 5000,
    });
  }

  // eslint-disable-next-line
  // const [role, setRole] = useState('');

  const initialValues = {
    email: '',
    password: '',
    confirmPassword: '',
    // role: '',
    // birthMonth: '',
    // birthYear: '',
    consent: '',
    subscribe: false,
  };

  const validationSchema = Yup.object({
    email: Yup.string().email('Invalid email address').required('Required'),
    password: Yup.string()
      .min(6, 'Password must be at least 6 characters')
      .required('Required'),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Passwords must match')
      .required('Required'),
    // role: Yup.string().required('Required'),
    // birthMonth: Yup.string().when('role', {
    //   is: 'student',
    //   then: () => Yup.string().required('Required'),
    // }),
    // birthYear: Yup.string().when('role', {
    //   is: 'student',
    //   then: () => Yup.string().required('Required'),
    // }),
    consent: Yup.string().required('Please select an option to continue.'),
  });

  const registerAccount = (values) => {
    // console.log('sign up with values: ', values);
    const body = {
      email: values.email,
      password: values.password,
      confirmPassword: values.confirmPassword,
      consent: values.consent,
      emailSubscription: values.subscribe,
      // userType: values.role,
      // birthYear: values.birthYear,
      // birthMonth: values.birthMonth,
    };
    api
      .post(`${API_BASE}/api/auth/registration`, body)
      .then((res) => {
        if (res.status == 200) {
          if (res.data?.message == "409001") {
            toastMessage("The email is already registered!");
          } else {
            navigate('/signup-confirmation');
          }
        }
      })
      .catch(() =>
        console.log('failed to sign up new user with email: ', values.email)
      );
  };

  return (
    <BackgroundWrapper applyMd={true}>
      <Box
        bg="white"
        p={8}
        width="500px"
        maxWidth="90%"
        borderRadius="lg"
        boxShadow="lg"
        mx="auto"
        mb={12}
        mt={{ base: 8, md: 28 }}
      >
        <Flex justifyContent="space-between" mb={6}>
          <Text fontSize="xl" fontWeight="bold">
            Sign Up
          </Text>

          <Link as={RouterLink} to="/signin" mt={2} color="teal.500">
            I have an account
          </Link>
        </Flex>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            registerAccount(values);
          }}
        >
          {({ handleSubmit, touched, errors, setFieldValue, values }) => (
            <Form onSubmit={handleSubmit}>
              <VStack spacing={4}>
                {/* Role Selector */}
                {/* <FormControl id="role" isRequired>
                <FormLabel>Sign up as</FormLabel>
                <Field
                  as={Select}
                  name="role"
                  placeholder="Select role"
                  onChange={(e) => {
                    handleChange(e);
                    setRole(e.target.value);
                  }}
                >
                  <option value="student">Student</option>
                  <option value="guardian">Parent</option>
                </Field>
                <ErrorMessage
                  name="role"
                  component="div"
                  style={{ color: 'red' }}
                />
              </FormControl> */}

                {/* {values.role === 'student' && (
                <>
                  <Text fontSize="sm" color="gray.600">
                    Note: A parent must register first for students under 13.
                  </Text>
                  <Stack
                    spacing={4}
                    direction={{ base: 'column', md: 'row' }}
                    w="100%"
                  >
                    <FormControl id="birth-month" isRequired>
                      <FormLabel>Birth Month</FormLabel>
                      <Field
                        as={Select}
                        name="birthMonth"
                        placeholder="Select month"
                      >
                        <option value="1">January</option>
                        <option value="2">February</option>
                        <option value="3">March</option>
                        
                      </Field>
                      <ErrorMessage
                        name="birthMonth"
                        component="div"
                        style={{ color: 'red' }}
                      />
                    </FormControl>

                    <FormControl id="birth-year" isRequired>
                      <FormLabel>Birth Year</FormLabel>
                      <Field
                        as={Select}
                        name="birthYear"
                        placeholder="Select year"
                      >
                        {Array.from({ length: 50 }, (_, i) => {
                          const year = new Date().getFullYear() - i - 13;
                          return (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          );
                        })}
                      </Field>
                      <ErrorMessage
                        name="birthYear"
                        component="div"
                        style={{ color: 'red' }}
                      />
                    </FormControl>
                  </Stack>
                </>
              )} */}

                {/* Email Field */}
                <FormControl id="email" isRequired>
                  <FormLabel>Email</FormLabel>
                  <Field
                    as={Input}
                    name="email"
                    type="email"
                    placeholder="Enter your email"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    style={{ color: 'red' }}
                  />
                </FormControl>

                {/* Password Field */}
                <FormControl id="password" isRequired>
                  <FormLabel>Password</FormLabel>
                  <Field
                    as={Input}
                    name="password"
                    type="password"
                    placeholder="Enter your password"
                  />
                  <ErrorMessage
                    name="password"
                    component="div"
                    style={{ color: 'red' }}
                  />
                </FormControl>

                {/* Confirm Password Field */}
                <FormControl id="confirmPassword" isRequired>
                  <FormLabel>Confirm Password</FormLabel>
                  <Field
                    as={Input}
                    name="confirmPassword"
                    type="password"
                    placeholder="Confirm your password"
                  />
                  <ErrorMessage
                    name="confirmPassword"
                    component="div"
                    style={{ color: 'red' }}
                  />
                </FormControl>

                <FormControl
                  as="fieldset"
                  isRequired
                  isInvalid={errors.consent && touched.consent}
                >
                  <FormLabel as="legend">User Confirmation</FormLabel>

                  <RadioGroup
                    value={values.consent}
                    onChange={(value) => setFieldValue('consent', value)}
                  >
                    <VStack align="start" spacing={3}>
                      <Radio value="student">
                        I am a student and confirm that I am 13 years old or
                        older.
                      </Radio>
                      <Radio value="guardian">
                        I am the parent or legal guardian and consent to the use
                        of the website.
                      </Radio>
                    </VStack>
                  </RadioGroup>

                  <FormErrorMessage>{errors.consent}</FormErrorMessage>
                </FormControl>

                {/* Subscribe to News Checkbox */}
                <FormControl>
                  <Field as={Checkbox} name="subscribe">
                    Subscribe to news from Dynivy Academy.
                  </Field>
                </FormControl>

                {/* Submit Button */}
                <Button
                  colorScheme="green"
                  size="md"
                  width="100%"
                  type="submit"
                >
                  Sign Up
                </Button>
              </VStack>
            </Form>
          )}
        </Formik>
      </Box>
    </BackgroundWrapper>
  );
};

export default Signup;
